import { ApplyFiltersBar } from '@statsbomb/kitbag-global-football';
import { useAtomValue } from 'jotai';
import { Suspense } from 'react';
import { playerAggsShowApplyButtonAtom } from '@/atoms/queries/player/playerAggData';
import { usePlayerDataLockerApplyFiltersButton } from '@/hooks/usePlayerDataLockerApplyFiltersButton';

const PlayerAggsApplyFiltersButtonWithData = () => {
  const showApplyFiltersButton = useAtomValue(playerAggsShowApplyButtonAtom);
  const { onApply, onCancel } = usePlayerDataLockerApplyFiltersButton();

  return <ApplyFiltersBar show={showApplyFiltersButton} onApply={onApply} onCancel={onCancel} />;
};

export const PlayerAggsApplyFiltersButton = () => (
  <Suspense>
    <PlayerAggsApplyFiltersButtonWithData />
  </Suspense>
);
